import { DefaultTheme } from 'styled-components';

export const theme: DefaultTheme = {
  colors: {
    primary: '#2563eb',
    secondary: '#3b82f6',
    text: {
      primary: '#1e293b',
      secondary: '#64748b',
    },
    background: {
      primary: '#ffffff',
      secondary: '#f8fafc',
    },
  },
  gradients: {
    primary: 'linear-gradient(135deg, #2563eb, #3b82f6)',
  },
}; 